import { useContext, useEffect, useRef } from "react";
import RefreshContext from "./RefreshContext";

// Runs a page's existing loader when the common Header refresh button is used.
export default function useHeaderRefresh(refresh) {
  const context = useContext(RefreshContext);
  const registerRefresh = context?.registerRefresh;
  const refreshRef = useRef(refresh);
  refreshRef.current = refresh;

  useEffect(() => {
    if (!registerRefresh) return undefined;
    return registerRefresh(() => refreshRef.current());
  }, [registerRefresh]);
}
